module.exports = __webpack_public_path__ + "img/IMG_9833.8391f2ea.jpg";